import {
  TREQUEST_GET_LINES_SHIFTS,
  TREQUEST_MM_GET_ALL_SHIFTS,
  TRESPONSE_GET_LINES_SHIFTS,
  TRESPONSE_MM_GET_ALL_SHIFTS,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TShiftManagementActionType } from './shift-management.models';

export class FetchAllShifts implements Action {
  readonly type = TShiftManagementActionType.FetchAllShifts;
  constructor(public payload: TREQUEST_MM_GET_ALL_SHIFTS) {}
}
export class FetchAllShiftsSuccess implements Action {
  readonly type = TShiftManagementActionType.FetchAllShiftsSuccess;
  constructor(public payload: TRESPONSE_MM_GET_ALL_SHIFTS) {}
}
export class FetchAllShiftsFailure implements Action {
  readonly type = TShiftManagementActionType.FetchAllShiftsFailure;
}

export class FetchLineShifts implements Action {
  readonly type = TShiftManagementActionType.FetchLineShifts;
  constructor(public payload: TREQUEST_GET_LINES_SHIFTS) {}
}
export class FetchLineShiftsSuccess implements Action {
  readonly type = TShiftManagementActionType.FetchLineShiftsSuccess;
  constructor(public payload: TRESPONSE_GET_LINES_SHIFTS) {}
}
export class FetchLineShiftsFailure implements Action {
  readonly type = TShiftManagementActionType.FetchLineShiftsFailure;
}

export type TShiftManagementActions =
  | FetchAllShifts
  | FetchAllShiftsSuccess
  | FetchAllShiftsFailure
  | FetchLineShifts
  | FetchLineShiftsSuccess
  | FetchLineShiftsFailure;
